module.exports = __webpack_public_path__ + "img/sideseam_small.16a34035.png";